import React, { useRef, useState, useEffect, useCallback } from 'react';
import '../../styles/HorizontalScrollRow.css';

function HorizontalScrollRow({ children, className = '', scrollClassName = '' }) {
  const scrollRef = useRef(null);
  const [canScrollBack, setCanScrollBack] = useState(false);
  const [canScrollForward, setCanScrollForward] = useState(false);

  const updateScrollState = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;

    const maxScroll = el.scrollWidth - el.clientWidth;
    if (maxScroll <= 2) {
      setCanScrollBack(false);
      setCanScrollForward(false);
      return;
    }

    setCanScrollBack(el.scrollLeft > 2);
    setCanScrollForward(el.scrollLeft < maxScroll - 2);
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return undefined;

    updateScrollState();

    el.addEventListener('scroll', updateScrollState, { passive: true });
    const observer = new ResizeObserver(updateScrollState);
    observer.observe(el);

    return () => {
      el.removeEventListener('scroll', updateScrollState);
      observer.disconnect();
    };
  }, [updateScrollState, children]);

  const scrollByStep = (direction) => {
    const el = scrollRef.current;
    if (!el) return;
    const step = Math.max(160, el.clientWidth * 0.65);
    el.scrollBy({ left: direction * step, behavior: 'smooth' });
  };

  const showArrows = canScrollBack || canScrollForward;

  return (
    <div className={`horizontal-scroll-row ${className}`.trim()}>
      <div
        ref={scrollRef}
        className={`horizontal-scroll-track ${showArrows ? 'has-arrows' : ''} ${scrollClassName}`.trim()}
      >
        {children}
      </div>

      {showArrows && (
        <>
          <button
            type="button"
            className="horizontal-scroll-arrow horizontal-scroll-arrow-back"
            onClick={() => scrollByStep(-1)}
            disabled={!canScrollBack}
            aria-label="عرض الخيارات السابقة"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
          <button
            type="button"
            className="horizontal-scroll-arrow horizontal-scroll-arrow-forward"
            onClick={() => scrollByStep(1)}
            disabled={!canScrollForward}
            aria-label="عرض المزيد من الخيارات"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
        </>
      )}
    </div>
  );
}

export default HorizontalScrollRow;
